module.exports = __webpack_public_path__ + "static/media/ladies-right.a5d9f057.png";